import { isAdminOrManager } from './roles'

export interface ClientTeam {
  clientSuccess?: string | null
  resumeWriter?: string | null
  coach?: string | null
}

export const TEAM_ROLES = [
  { key: 'clientSuccess', label: 'Client Success' },
  { key: 'resumeWriter', label: 'Resume Writer' },
  { key: 'coach', label: 'Coach' },
] as const

export type TeamRoleKey = (typeof TEAM_ROLES)[number]['key']

export interface TeamRoleRow {
  key: TeamRoleKey
  label: string
  /** Email stored on the client, or null when the role is unassigned. */
  email: string | null
  /** Display name for the assignee, or null when unassigned. */
  name: string | null
}

export function missingTeamRoles(team: ClientTeam | undefined | null): string[] {
  return TEAM_ROLES.filter((role) => !team?.[role.key]).map((role) => role.label)
}

// Saving a team needs an admin or manager (assign-client-team returns 403 otherwise).
export function canAssignTeam(user: { role?: string; isManager?: boolean } | null): boolean {
  return isAdminOrManager(user)
}

// Assignments are stored as emails. Falls back to the part before the @ (what the
// client header shows) when the user is not in the lookup, e.g. a deactivated one.
export function teamRoleRows(
  team: ClientTeam | undefined | null,
  nameByEmail: Record<string, string> = {}
): TeamRoleRow[] {
  return TEAM_ROLES.map(({ key, label }) => {
    const email = team?.[key] || null
    return {
      key,
      label,
      email,
      name: email ? nameByEmail[email] || email.split('@')[0] : null,
    }
  })
}
